import { getInitialState, getPath } from "../../utils";

const initialState = {
  assetList: [],
  prevPage: -1,
  nextPage: -1,
  activeAsset: {},
  activeFilters: {},
  currentPage: 1,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "SET_ASSET_LIST":
      return setAssetList(state, action);
    case "SET_ACTIVE_ASSET":
      return setActiveAsset(state, action);
    case "SET_ACTIVE_FILTERS":
      return setActiveFilters(state, action);
    case "SET_CURRENT_PAGE_ASSET":
      return setCurrentPageAsset(state, action);
    case "RESET_STATE_ASSET":
      return resetStateFeature(state, action);
    default:
      return state;
  }
}

const setCurrentPageAsset = (state, action) => {
  return {
    ...state,
    currentPage: action.payload,
  };
};

const setAssetList = (state, action) => {
  console.log("setAssetList", action.payload, getPath(action.payload));
  return {
    ...state,
    assetList: getPath(action.payload, "data.assets", []),
    prevPage: getPath(action.payload, "page_response.previous_page", -1),
    nextPage: getPath(action.payload, "page_response.next_page", -1),
  };
};

const resetStateFeature = (state, action) => {
  return {
    ...state,
    [action.payload.state]: getInitialState(initialState, action.payload.state),
  };
};

const setActiveAsset = (state, action) => {
  return {
    ...state,
    activeAsset: action.payload,
  };
};

const setActiveFilters = (state, action) => {
  return {
    ...state,
    activeFilters: action.payload,
  };
};
